import {ParentAsset} from "./ParentAsset";
import {FileMetaData} from "./FileMetaData";
import {LineSegment} from "./LineSegment";

export abstract class CommonAsset {
  uniqueAssetIdThingWorksFK?: string;
  assetId?: number;
  assetFriendlyName?: string;
  serialNumber?: string;
  modelName?: string;
  yearManufactured?: number;
  commentText?: string;
  lineId?: number;
  lineName?: string;
  lineTier?: string;
  parentAssetList?: Array<ParentAsset>;
  lineLayoutWeight?: number;
  placeholderAsset?: boolean;
  plantId?: number;
  plantName?: string;
  plantUtcOffset?: number;
  companyId?: number;
  companyName?: string;
  roomId?: number;
  roomName?: string;
  assetDocuments?: Array<FileMetaData>;
  assetImages?: Array<FileMetaData>;
  countryName?: string;
  assetTypeId?: number;
  assetTypeText?: string;
  regionName?: string;
  awsRegion?: string;
  iotRuleName?: string;
  createdDate?: number;
  createdUser?: string;
  modifiedDate?: number;
  modifiedUser?: string;

  static setParentAssets(asset?: CommonAsset, assetIds?: Array<number>, placeholderAsset?: boolean) {
    if (asset instanceof CommonAsset) {
      asset.parentAssetList = [];
      if (assetIds) {
        assetIds.forEach((assetId) => {
          let parentAssetId = new ParentAsset();
          parentAssetId.assetId = assetId;
          parentAssetId.placeholderAsset = placeholderAsset;
          if (asset.parentAssetList) {
            asset.parentAssetList.push(parentAssetId);
          }
        });
      }
    }
  }

  static setAssetDocuments(asset?: CommonAsset, ids?: Array<number>) {
    if (asset instanceof CommonAsset) {
      asset.assetDocuments = [];
      if (ids) {
        ids.forEach((id) => {
          let file = new FileMetaData();
          file.fileId = id;
          if (asset.assetDocuments) {
            asset.assetDocuments.push(file);
          }
        });
      }
    }
  }

  static setAssetImages(asset?: CommonAsset, ids?: Array<number>) {
    if (asset instanceof CommonAsset) {
      asset.assetImages = [];
      if (ids) {
        ids.forEach((id) => {
          let file = new FileMetaData();
          file.fileId = id;
          if (asset.assetImages) {
            asset.assetImages.push(file);
          }
        });
      }
    }

  }

  static getModelAndSerialNumber(asset?: CommonAsset) {
    if (asset) {
      if(asset.modelName && asset.serialNumber) {
        return `${asset.modelName} ${asset.serialNumber}`;
      }
    }

    return '';
  }

  static getFriendlyDisplayName(asset: CommonAsset) :string | undefined {
    if(asset.assetFriendlyName) {
      return asset.assetFriendlyName;
    }
    else if(asset.modelName && asset.serialNumber) {
      return `${asset.modelName} ${asset.serialNumber}`;
    }
    return asset.uniqueAssetIdThingWorksFK;
  }
}
